import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { Gift, Loader2 } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { useCart } from "@/lib/cart";
import { useI18n } from "@/lib/i18n";
import { storefrontSdk } from "@/lib/sdk";

export const Route = createFileRoute("/o/$token")({
  component: OfferLanding,
});

function OfferLanding() {
  const { token } = Route.useParams();
  const { t, lang } = useI18n();
  const {
    cart,
    lineCount,
    hydrated,
    setPromotionAttribution,
    clearPromotionAttribution,
  } = useCart();
  const navigate = useNavigate();
  const started = useRef(false);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!hydrated || started.current) return;
    started.current = true;
    void storefrontSdk
      .offerAttribution(token)
      .then((attribution) => {
        setPromotionAttribution(attribution);
        const offer =
          attribution.promotion.name[lang] ??
          attribution.promotion.name["en"] ??
          attribution.promotion.name["ar"] ??
          "";
        toast.success(t("offer.ready", { offer }));
        return navigate({
          to:
            lineCount > 0 ? "/cart" : cart.orderType ? "/menu" : "/order-type",
        });
      })
      .catch(() => {
        clearPromotionAttribution();
        setFailed(true);
      });
  }, [
    cart.orderType,
    clearPromotionAttribution,
    hydrated,
    lang,
    lineCount,
    navigate,
    setPromotionAttribution,
    t,
    token,
  ]);

  return (
    <section className="pattern-levant grid min-h-[70vh] place-items-center px-4 py-12">
      <div className="surface-card w-full max-w-md p-8 text-center sm:p-10">
        <span className="mx-auto grid size-16 place-items-center rounded-full bg-primary/10 text-primary">
          {failed ? (
            <Gift className="size-8" aria-hidden="true" />
          ) : (
            <Loader2 className="size-8 animate-spin" aria-hidden="true" />
          )}
        </span>
        <h1 className="mt-5 text-2xl font-black">
          {t(failed ? "offer.unavailableTitle" : "offer.loading")}
        </h1>
        <p className="mt-2 text-sm leading-6 text-muted-foreground">
          {t(failed ? "offer.unavailable" : "offer.loadingHint")}
        </p>
        {failed ? (
          <Button asChild className="mt-6 w-full" size="lg">
            <Link to="/">{t("offer.continue")}</Link>
          </Button>
        ) : null}
      </div>
    </section>
  );
}
